// extracted by mini-css-extract-plugin
export default {"button":"AlertDialog_button__shLwf","button-pop":"AlertDialog_button-pop__Wm+1q"};